export default "__VITE_ASSET__C7KuZPN6__"